import { atom } from 'jotai';

// Stores the latest 5-bar heights from Tauri AUDIO_LEVELS events (0..50 each).
// Undefined means no levels received yet / not in Tauri.
export const tauriAudioLevelsAtom = atom<number[] | undefined>(undefined);
